import { render, staticRenderFns } from "./UploadedMediaCard.vue?vue&type=template&id=022c9eb8&"
import script from "./UploadedMediaCard.vue?vue&type=script&lang=js&"
export * from "./UploadedMediaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports